<template>
    <el-dialog title="查看物流" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="900px" @close="dialogFormVisible">
        <el-tabs type="border-card" v-model="supplier_id" @tab-click="handleClick">
            <el-tab-pane v-for="item in supplierList" :key="item.order_supplier_id" :label="item.supplier.supplier_name" :name="''+item.supplier_id"></el-tab-pane>


            <el-timeline :reverse="reverse" v-if="activities.length">
                <el-timeline-item v-for="(activity, index) in activities" :key="index" :color="index == 0 ? '#2ECC40' : ''" :timestamp="activity.time">
                    {{ activity.context }}
                </el-timeline-item>
            </el-timeline>
            <div v-else>
                <el-alert :title="'暂无物流信息'" type="info" :closable="false"></el-alert>
            </div>
        </el-tabs>
    </el-dialog>
</template>

<script>
    import OrderApi from "@/api/order.js";
    export default {
        props: [],
        data() {
            return {
                /*是否显示*/
                dialogVisible: false,
                /*结果类别*/
                type: "error",
                /*传出去的参数*/
                params: null,
                reverse: false,
                order_id: 0,
                activities: [],

                supplier_id : '',
                supplierList: []
            };
        },
        watch: {
            isLogistics: function(n, o) {
                if (n != o) {
                    if (n) {
                        this.dialogVisible = n;
                        this.type = "error";
                    }
                }
            },
            logisticsData: function(n, o) {
                if (n != o) {
                    if (n) {
                        this.activities = n;
                        console.log(this.activities);
                    }
                }
            }
        },
        methods: {
            handleClick(tab, event){
                console.log(tab, event);
                console.log(tab.name);
                let supplier_id = tab.name;
                //筛选对应的物流
                for(let i = 0; i < this.supplierList.length; i++){
                    if(this.supplierList[i].supplier_id == supplier_id){
                        this.activities = this.supplierList[i].express;
                        return;
                    }
                }

            },
            showDialog(row){
                this.dialogVisible = true;
                this.getData(row);
            },
            getData(row) {
                let self = this;
                let Params = {
                    order_id: row.order_id,
                }
                self.loading = true;
                OrderApi.queryLogistics(Params, true)
                    .then(res => {
                        self.loading = false;
                        self.supplierList = res.data.list;
                        self.supplier_id = ''+res.data.list[0].supplier_id;
                        self.activities = res.data.list[0].express;
                        console.log(self.activities)
                        self.openLogistics()
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },
            /*关闭弹窗*/
            dialogFormVisible() {
                this.$emit("closeDialog", {
                    type: this.type,
                    openDialog: false,
                    params: this.params
                });
            }
        }
    };
</script>

<style>
    .el-step__main .el-step__description {
        padding-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/logistics/viewLogistics.vue